// Recovered compiled webpack factory 33698. Edit this function expression; run npm run build.
(e, t, n) => {
  "use strict";
  n.d(t, { i: () => o });
  var r = n(12115),
    i = n(16612);
  let a = { policy: null, loading: !1 };
  function o() {
    return (0, r.useSyncExternalStore)(i.B1, i.PS, () => a);
  }
}
